// Function to close all modals
function closeAllModals() {
  document.querySelectorAll(".icon-btn").forEach((btn) =>
    btn.classList.remove("active")
  );
  document.querySelectorAll(".utility-modal").forEach((modal) =>
    modal.classList.remove("visible")
  );
}

// Delegated click listener for modal buttons
document.addEventListener("click", function (event) {
  const button = event.target.closest(".icon-btn");
  const utilityGroup = event.target.closest(".utility");

  if (button && utilityGroup) {
    event.stopPropagation();

    const modal = utilityGroup.querySelector(".utility-modal");

    if (!modal) return;

    // Close other modals
    closeAllModals();

    // Open this one
    button.classList.add("active");
    modal.classList.add("visible");

    return; // prevent the global click handler from immediately closing it
  }

  // Prevent clicks inside modal from closing it
  if (event.target.closest(".utility-modal")) {
    event.stopPropagation();
    return;
  }

  // Click outside closes all modals
  closeAllModals();
});
